export default __webpack_public_path__ + "static/media/openapi_compass_external.324d006a.txt";